import {
  ModelStringKeyConditionInput,
  ModelSortDirection,
  EventActionType,
  EventObjectType,
  EventLevel,
  ModelEventFilterInput,
} from '@/api';
import { ConstructorInput } from '@/services/event';
import { graphql } from '@/utils/graphql';

export async function noLint_listEventsByWorkspace(
  limit: number,
  params: {
    // just infer this type from usage
    actionSourceWorkspaceId: string | undefined;
    actionRecordedAt: ModelStringKeyConditionInput | { between: string[] } | undefined;
    sortDirection: ModelSortDirection | undefined;
    filter:
      | {
          or: { actionType: { eq: EventActionType } }[] | undefined;
          actionSourceName: { contains: string } | undefined;
          actionSourceType: { eq: EventObjectType } | undefined;
          level: { eq: EventLevel } | undefined;
        }
      | ModelEventFilterInput
      | undefined;
    limit?: number | undefined;
    nextToken?: string | undefined;
  },
): Promise<ConstructorInput[]> {
  let items: ConstructorInput[] = [];
  let nextToken: string | undefined;
  do {
    const data = await graphql(
      'listEventsByWorkspace',
      {
        ...params,
        nextToken,
      },
      true,
    );
    const newItems = data.items;
    if (newItems.length) items = items.concat(newItems);
    nextToken = data.nextToken;
  } while (nextToken && items.length < limit);

  return items;
}
